import { HttpClient } from '@angular/common/http';
import BigNumber from 'bignumber.js';
import { tap } from 'rxjs/operators';
import { Base } from '../base';

export class Config extends Base {
  constructor(protected httpClient: HttpClient, private parent: string) {
    super(httpClient, `${parent}/config`);
  }

  query() {
    return this.api.query().pipe(
      tap((json) => this.processRecord(json.config))
    );
  }

  private processRecord(record: any) {
    record.initialMarginRiskRate = new BigNumber(record.initialMarginRiskRate).fromDecimal();
    record.liquidateRate = new BigNumber(record.liquidateRate).fromDecimal();
    record.clearRate = new BigNumber(record.clearRate).fromDecimal();
    record.liquidationReward = new BigNumber(record.liquidationReward).fromDecimal();
    record.minLiquidation = new BigNumber(record.minLiquidation).fromDecimal();
    record.riskFreeRate = new BigNumber(record.riskFreeRate).fromDecimal();
    record.priceRatio = new BigNumber(record.priceRatio).fromDecimal();
    record.priceRatio2 = new BigNumber(record.priceRatio2).fromDecimal();
    record.priceRatioUtilization = new BigNumber(record.priceRatioUtilization).fromDecimal();
    record.spotFee = new BigNumber(record.spotFee).fromDecimal();
    record.optionFee = new BigNumber(record.optionFee).fromDecimal();
    record.minPremium = new BigNumber(record.minPremium).fromDecimal();
    record.exerciseFeeRate = new BigNumber(record.exerciseFeeRate).fromDecimal();
    record.profitFeeRate = new BigNumber(record.profitFeeRate).fromDecimal();
    record.poolProportion = new BigNumber(record.poolProportion).fromDecimal();
    record.insuranceProportion = new BigNumber(record.insuranceProportion).fromDecimal();
  }
}
